import styled from 'styled-components';
import { Box } from '@components/common';

const CalendarButtonContainer = styled(Box)`
  display: flex;
  align-self: stretch;
  flex-direction: row;
  height: 100%;

  border: 0;
  border-right: 1px solid rgb(216, 216, 216);

  &:last-child {
    border-right: 0;
  }
`;

export default CalendarButtonContainer;
